import { Box, Typography } from "@mui/material";
import { Investment } from "@rentablo/api/apiv1";
import { CardHeading } from "@rentablo/components";
import { CurrencyToggle } from "@components";
import { useCurrencyDisplay } from "@providers/CurrencyDisplayProvider";
import { InvestmentPageActions } from "./InvestmentPageActions";

interface Props {
  investmentId: number;
  investment?: Investment;
}

export const InvestmentPageHeading = ({ investmentId, investment }: Props) => {
  const { globalCurrency } = useCurrencyDisplay();
  const hasForeignCurrency = Boolean(
    investment?.currency &&
      investment.currency.toUpperCase() !== globalCurrency.toUpperCase()
  );
  return (
    <CardHeading
      actionsInline
      title={
        <Typography component="h1" variant="h4">
          {investment?.standardisedName || investment?.name || investment?.isin}
        </Typography>
      }
      actions={
        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-end"
          gap={2}
        >
          <InvestmentPageActions
            investmentId={investmentId}
            investmentName={
              investment?.standardisedName || investment?.name || undefined
            }
          />
          <Box sx={{ display: { xs: "none", md: "block" } }}>
            <CurrencyToggle
              storageKey="currency-toggle-investment"
              originalCurrency={investment?.currency}
            />
          </Box>
        </Box>
      }
      // Only with a currency to switch: an empty slot would still add the
      // heading's gap above the chart.
      below={
        hasForeignCurrency ? (
          <Box
            sx={{
              display: { xs: "flex", md: "none" },
              justifyContent: "flex-start",
              width: "100%",
            }}
          >
            <CurrencyToggle
              storageKey="currency-toggle-investment"
              originalCurrency={investment?.currency}
            />
          </Box>
        ) : undefined
      }
    />
  );
};
